"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RequiredOption_1 = require("../RequiredOption");
class SupportingCreativeFormatPlaybackTimeItem {
    constructor({ seconds, requiredOption }) {
        this.toJSON = () => ({
            seconds: this.seconds,
            requiredOption: this.requiredOption,
        });
        this.seconds = seconds;
        this.requiredOption = requiredOption;
    }
}
SupportingCreativeFormatPlaybackTimeItem.fromJSON = (json) => {
    const { seconds, requiredOption } = Object.assign({}, json);
    const _requiredOption = requiredOption ? RequiredOption_1.default.fromJSON(requiredOption) : undefined;
    if (!Number.isSafeInteger(seconds))
        throw new Error('.seconds must be an integer');
    return new SupportingCreativeFormatPlaybackTimeItem({
        seconds,
        requiredOption: _requiredOption,
    });
};
exports.default = SupportingCreativeFormatPlaybackTimeItem;
